var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPosListSideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4587_4490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0634 5.03333C20.0642 4.93658 20.0268 4.8434 19.9592 4.7741L16.2926 1.10743C16.2236 1.03942 16.1302 1.00192 16.0333 1.0033V1H5.03334C4.42582 1 3.93334 1.49248 3.93334 2.1V21.9C3.93334 22.5075 4.42582 23 5.03334 23H18.9667C19.5742 23 20.0667 22.5075 20.0667 21.9V5.03333H20.0634ZM16.4 2.2518L18.8149 4.66667H16.7667C16.5642 4.66667 16.4 4.50249 16.4 4.3V2.2518ZM19.3333 21.9C19.3333 22.1025 19.1692 22.2667 18.9667 22.2667H5.03334C4.83085 22.2667 4.66667 22.1025 4.66667 21.9V2.1C4.66667 1.89751 4.83085 1.73333 5.03334 1.73333H15.6667V4.3C15.6667 4.90752 16.1592 5.4 16.7667 5.4H19.3333V21.9Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 10.9C6.99248 10.9 6.5 11.3925 6.5 12C6.5 12.6075 6.99248 13.1 7.6 13.1C8.20752 13.1 8.7 12.6075 8.7 12C8.7 11.3925 8.20752 10.9 7.6 10.9ZM7.6 12.3667C7.39751 12.3667 7.23333 12.2025 7.23333 12C7.23333 11.7975 7.39751 11.6334 7.6 11.6334C7.80249 11.6334 7.96667 11.7975 7.96667 12C7.96667 12.2025 7.80249 12.3667 7.6 12.3667Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.6333H10.1667V12.3666H17.5V11.6333Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 7.23328C6.99248 7.23328 6.5 7.72576 6.5 8.33328C6.5 8.9408 6.99248 9.43328 7.6 9.43328C8.20752 9.43328 8.7 8.9408 8.7 8.33328C8.7 7.72576 8.20752 7.23328 7.6 7.23328ZM7.6 8.69994C7.39751 8.69994 7.23333 8.53577 7.23333 8.33328C7.23333 8.13078 7.39751 7.96661 7.6 7.96661C7.80249 7.96661 7.96667 8.13078 7.96667 8.33328C7.96667 8.53577 7.80249 8.69994 7.6 8.69994Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.96667H10.1667V8.70001H17.5V7.96667Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 14.5667C6.99248 14.5667 6.5 15.0591 6.5 15.6666C6.5 16.2742 6.99248 16.7666 7.6 16.7666C8.20752 16.7666 8.7 16.2742 8.7 15.6666C8.7 15.0591 8.20752 14.5667 7.6 14.5667ZM7.6 16.0333C7.39751 16.0333 7.23333 15.8691 7.23333 15.6666C7.23333 15.4642 7.39751 15.3 7.6 15.3C7.80249 15.3 7.96667 15.4642 7.96667 15.6666C7.96667 15.8691 7.80249 16.0333 7.6 16.0333Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.3H10.1667V16.0334H17.5V15.3Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 18.2333C6.99248 18.2333 6.5 18.7258 6.5 19.3333C6.5 19.9408 6.99248 20.4333 7.6 20.4333C8.20752 20.4333 8.7 19.9408 8.7 19.3333C8.7 18.7258 8.20752 18.2333 7.6 18.2333ZM7.6 19.6999C7.39751 19.6999 7.23333 19.5358 7.23333 19.3333C7.23333 19.1308 7.39751 18.9666 7.6 18.9666C7.80249 18.9666 7.96667 19.1308 7.96667 19.3333C7.96667 19.5358 7.80249 19.6999 7.6 19.6999Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.9667H10.1667V19.7H17.5V18.9667Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4587_4490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white",
    transform: "translate(3 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosListSideMenu);
export default __webpack_public_path__ + "static/media/PosListSideMenu.4d92964e30f225a5a1ae49d74bcffb59.svg";
export { ForwardRef as ReactComponent };